import { SET_CONTACT_COMP_MODAL_STATE } from '../actions/types'

const defaultState = {
  contactModalVisible: false,
  contactModalContent: {},
}

// const defaultState = {
//   contactModalVisible: false,
//   contactModalContent: {},
// };

const contactCompModalState = (state = defaultState, action) => {
  const { type, payload } = action
  switch (type) {
    case SET_CONTACT_COMP_MODAL_STATE:
      return {
        ...state,
        ...payload,
      }
    default:
      return state
  }
}
export default contactCompModalState
